import { useState } from "react";

import { useWebSettings } from "@/models/StateProviders/WebSettingsProvider";

/**
 * The `localStorage` key whose value `"true"` turns the reassignment prototype on in this browser alone.
 *
 * The demo switch for a local web build against a shared stage; `web.dispatch.reassignment` in a member's own config is
 * how a member gets the prototype without it.
 */
export const REASSIGNMENT_OVERRIDE_KEY = "sb.dispatch.reassignment";

/** Whether this browser carries the override; storage that is blocked or throws reads as unset. */
function readReassignmentOverride(): boolean {
  try {
    return window.localStorage.getItem(REASSIGNMENT_OVERRIDE_KEY) === "true";
  } catch {
    return false;
  }
}

/**
 * Whether the Dispatch page's task reassignment prototype is on for the viewer.
 *
 * On when the member's compiled `web.dispatch.reassignment` is true, or when this browser carries
 * {@link REASSIGNMENT_OVERRIDE_KEY}. The override is read once per mount, so setting it takes a reload.
 */
export function useReassignmentEnabled(): boolean {
  const { settings } = useWebSettings();
  const [override] = useState(readReassignmentOverride);
  return settings.dispatch.reassignment || override;
}
